'use client'

import { NextUIProvider } from '@nextui-org/system'

import { FC, ReactNode } from 'react'

// interface
interface ILayoutProviderProps {
  children: ReactNode
}

// component
const NextUiProvider: FC<Readonly<ILayoutProviderProps>> = (props) => {
  const { children } = props

  // return
  return <NextUIProvider locale={'uk'}>{children}</NextUIProvider>
}

export default NextUiProvider
